import {Project} from "./Project";
import {Task} from "./Task";

export const projectVisitTypeEnum = {
  'Voor uitvoering': 'Voor uitvoering',
  'Na uitvoering': 'Na uitvoering',
  'Werkopname': 'Werkopname'
}

export type ProjectVisitType = keyof typeof projectVisitTypeEnum;

export const projectVisitStatusEnum = {
  'Concept': 'Concept',
  'Taak aangemaakt': 'Taak aangemaakt',
  'Ingepland': 'Ingepland',
  'Uitgevoerd': 'Uitgevoerd'
}

export type ProjectVisitStatus = keyof typeof projectVisitStatusEnum;

export class ProjectVisit {
  constructor(
    public readonly id: string,
    public readonly projectId: string,
    public readonly taskId: string,
    public readonly type: ProjectVisitType,
    public readonly targetDate: Date,
    public readonly offsetBeforeExecutionDate: number,
    public readonly status: ProjectVisitStatus,
    public readonly name: string,
    public readonly createdAt: Date,
    public readonly UpdatedAt: Date,
    public readonly deletedAt: Date|null,
    public readonly project: Project|null,
    public readonly task: Task|null,
  ) {
  }

  static fromJson(json: any): ProjectVisit {
    return new ProjectVisit(
      json['id'],
      json['project_id'],
      json['task_id'],
      json['type'],
      new Date(json['target_date']),
      json['offset_before_execution_date'],
      json['status'],
      json['name'],
      new Date(json['created_at']),
      new Date(json['updated_at']),
      json['deleted_at'] ? new Date(json['deleted_at']) : null,
      json['project'] ? Project.fromJson(json['project']) : null,
      json['task'] ? Task.fromJson(json['task']) : null,
    );
  }
}